import {useEffect, useMemo, useRef, useState} from 'react'
import { Button, message, Select, Switch, Tooltip, TreeSelect, Upload } from 'antd'
import {
  SActionBtn,
  SDrawerOrModal,
  SGeneralForms,
  SLocalTreeSelected,
  SLowcodeList,
  SMessage,
  STableActions,
} from 'shj-components'
import {cloneDeep, isArray, isEmpty} from 'lodash-es'

import {
  getProductCategoryTreeList,
  getSpecialCodesList,
  productCategoryDelete,
  ProductCategoryImportCategory,
  productCategorySave,
  productCategoryUpdateById,
} from '@/services/product.ts'
import {config} from './config'
import {deleteObjNodeById, trimStr} from '@/utils/data.ts'
import {DownloadOutlined, UploadOutlined} from '@ant-design/icons'
import {useSetState} from 'ahooks'
import {fileDownload} from '@/utils/download'
import UrlConfig from '@/api/UrlConfigs'
import BelongProductLibraryModal from "@/pages/productClass/components/BelongProductLibraryModal";
import RelatedConstructionModal from "@/pages/productClass/components/RelatedConstructionModal";

export default function ProductClass() {
  const listRef = useRef<any>()
  const formRef = useRef<any>()
  const [open, setOpen] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const [record, setRecord] = useState<any>({})
  const [parentList, setParentList] = useState<any[]>([])
  const [state, setState] = useSetState({
    exportLoading: false,
    importLoading: false,
    specialCodeList: [],
    productCategoryModalOpen: false, // 所属产品库弹窗
    relatedConstructionModalOpen: false, // 关联施工弹窗
    selectedRowKeys: [],
    record: {},
  })

  const fetchList = ({current, pageSize, query}) => {
    return new Promise(async (resolve, reject) => {
      getProductCategoryTreeList({ ...query, querySpuRelation: true })
        .then((res: any) => {
          const data = isArray(res) ? res : []
          resolve({records: data})
          setParentList(data)
        })
        .catch(reject)
    })
  }

  const onAdd = () => onEdit()
  const onEdit = (record = {}, isParent = false) => {
    setOpen(true)
    // isParent true 添加下级
    setRecord(isParent ? {parentId: record.id} : record)
  }

  useEffect(() => {
    formRef.current?.onFormRef()?.resetFields()
    if (open && !isEmpty(record)) {
      console.log(record, 'record')

      // const cateIdPath = record.cateIdPath?.split('>')
      // const parentIdPath = cateIdPath?.slice(
      //   0,
      //   record.id ? cateIdPath.length - 1 : cateIdPath.length
      // )
      record.parentId = record.parentId === '0' ? undefined : record.parentId
      formRef.current?.onFormRef()?.setFieldsValue({...record})
    } else {
      setRecord({})
    }
  }, [open])

  const newTreeData = useMemo(() => {
    const data = cloneDeep(parentList)
    if (record.id && !isEmpty(data)) {
      deleteObjNodeById(data, record.parentId, record.id)
    }
    return data
  }, [parentList, record.id])

  //  表格事件: 删除
  const onDel = id => {
    SMessage.confirm({
      onOk: () => {
        return productCategoryDelete(id).then((res: any) => {
          message.success(res.message || '操作成功')
          listRef.current?.reload()
        })
      },
    })
  }

  const onChangeStatus = (enabled: boolean, record) => {
    SMessage.confirm({
      title: '修改状态',
      content: `是否确认${enabled ? '启用' : '禁用'}该数据`,
      onOk: () => {
        return productCategoryUpdateById({...record, enabled}).then((res: any) => {
          message.success(res.message || '操作成功')
          listRef.current?.reload()
        })
      },
    })
  }

  const onSubmit = () => {
    formRef.current
      ?.onFormRef()
      .validateFields()
      .then(values => {
        console.log(values, 'values')
        values.parentId = isArray(values.parentId)
          ? values.parentId[values.parentId.length - 1]
          : values.parentId
        setBtnLoading(true)
        const values_ = {
          ...values,
        }
        const apiUrl = values.id ? productCategoryUpdateById : productCategorySave
        apiUrl(values_)
          .then((res: any) => {
            message.success(res.message || '操作成功')
            listRef.current?.reload()
            setOpen(false)
          })
          .finally(() => {
            setBtnLoading(false)
          })
      })
  }
  const onImport = (upload: any) => {
    setState({importLoading: true})
    const {file, onSuccess, onError} = upload
    const data = new FormData()
    data.append('file', file)
    return ProductCategoryImportCategory(data)
      .then((res: any) => {
        listRef.current && listRef.current.reload()
        onSuccess && onSuccess()
        message.success(res.message || '导入成功')
      })
      .catch(onError)
      .finally(() => setState({importLoading: false}))
  }

  const onExport = () => {
    setState({exportLoading: true})
    fileDownload(UrlConfig.PlusProductWeb.ProductCategoryTemplateDownload)
      .then(() => setState({exportLoading: false}))
      .catch(() => setState({exportLoading: false}))
  }

  const onChangeProductLibrary = ({selectedRows, selectedRowKeys}) => {
    const isTop = selectedRows.every(item => !item.parentId || item.parentId == '0')
    if (!isTop){
      message.error('只有一级分类可设置所属产品库！')
      return;
    }
    setState({productCategoryModalOpen: true, selectedRowKeys})
  }

  const onRelatedConstructionOne = (record) => {
    onRelatedConstruction({selectedRowKeys: [record.id], selectedRows: [record]}, false)
  }

  const onRelatedConstruction = ({selectedRows, selectedRowKeys}, isBatch = true) => {
    const isBottom = selectedRows.every(item => !item.children)
    if (!isBottom){
      message.error('只有末级分类可进行该设置！')
      return;
    }
    console.log(selectedRows)
    if (isBatch) {
      setState({selectedRowKeys})
    } else {
      setState({record: selectedRows[0]})
    }
    setState({relatedConstructionModalOpen: true})
  }

  const extensions = {
    request: {fetchList},
    events: {
      onAdd,
      onChangeProductLibrary,
      onRelatedConstruction: ({selectedRows, selectedRowKeys}) => onRelatedConstruction({selectedRows, selectedRowKeys}),
    },
    status: {
      selectedDisabled: ({selectedRowKeys}: any) => !selectedRowKeys.length,
      radioDisabled: ({selectedRowKeys}: any) => selectedRowKeys.length !== 1,
    },
    customRender: {
      switchRender(v: boolean, record: Record<string, any>) {
        return <Switch checked={v} checkedChildren="启用" unCheckedChildren="禁用"
                       onClick={checked => onChangeStatus(checked, record)}/>
      },
      skuNameRender(v){
        const names = v?.filter?.(item => item.filterSkuListNames)?.map?.(item => item.filterSkuListNames)
        const str = names?.join?.(',')
        return <Tooltip title={str} overlayStyle={{maxWidth: 500, maxHeight: 300, overflowY: 'auto'}}>
          <div style={{width: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{str}</div>
        </Tooltip>
      },
      addRender: () => {
        return (
          <Button type={'primary'} onClick={onAdd}>
            新增
          </Button>
        )
      },
      actionRender(_, record: Record<string, any>) {
        return (
          <STableActions>
            <SActionBtn onClick={() => onEdit(record)}>编辑</SActionBtn>
            <SActionBtn onClick={() => onEdit(record, true)}>添加下级</SActionBtn>
            {/*{!record.children && <SActionBtn onClick={() => onRelatedConstructionOne(record)}>关联施工</SActionBtn>}*/}
            {!record.systemCategory && (
              <SActionBtn danger onClick={() => onDel(record.id)}>
                删除
              </SActionBtn>
            )}
          </STableActions>
        )
      },
      importRender: () => {
        return (
          <Upload listType="text" customRequest={onImport} itemRender={() => null}>
            <Button
              type={'primary'}
              loading={state.importLoading}
              disabled={state.importLoading}
              icon={<UploadOutlined/>}
            >
              批量导入
            </Button>
          </Upload>
        )
      },
      exportRender: () => {
        return (
          <Button
            icon={<DownloadOutlined/>}
            onClick={onExport}
            disabled={state.exportLoading}
            loading={state.exportLoading}
            type="dashed"
          >
            下载导入模板
          </Button>
        )
      },
    },
  }
  const getOptions = async () => {
    let specialCodeList: any = await getSpecialCodesList({
      data: {},
    })
    specialCodeList = specialCodeList.map(item => ({label: item.showName, value: item.code}))
    setState({specialCodeList})
    return Promise.resolve({specialCodeList})
  }
  return (
    <div>
      <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} />
      <SDrawerOrModal
        title={(record.id ? '编辑' : '新增') + '分类'}
        mode="modal"
        open={open}
        loading={btnLoading}
        onCancel={() => setOpen(false)}
        onOk={onSubmit}
        width={500}
      >
        <SGeneralForms
          ref={formRef}
          initialValues={{...record, parentId: record.parentId == 0 ? '' : record.parentId}}
          layout={'vertical'}
          httpOptionsFn={getOptions}
          configs={[
            {
              formItem: [
                {label: 'id', name: 'id', hidden: true},
                {
                  label: '父级分类',
                  name: 'parentId',
                  spanCol: 24,
                  hidden: !record.id,
                  children: (
                    <SLocalTreeSelected
                      treeDefaultExpandAll
                      showCheckedStrategy={TreeSelect.SHOW_PARENT}
                      fieldNames={{label: 'cateName', value: 'id'}}
                      treeData={newTreeData}
                    />
                  ),
                },
                {
                  label: '分类名称',
                  name: 'cateName',
                  spanCol: 24,
                  required: true,
                  rules: [{required: true, message: '分类名称不能为空'}],
                  comConfig: {
                    showCount: true,
                    maxLength: 30,
                    onChange: e =>
                      formRef.current
                        ?.onFormRef()
                        ?.setFieldValue('cateName', trimStr(e.target.value)),
                  },
                },
                {
                  name: 'specialCode',
                  label: '特项代码',
                  spanCol: 24,
                  children: (
                    <Select
                      allowClear
                      placeholder="请选择"
                      style={{width: 460}}
                      options={state.specialCodeList}
                      showSearch
                      filterOption={(input, option) =>
                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                      }
                      onChange={e => formRef.current?.onFormRef()?.setFieldValue('specialCode', e)}
                    />
                  ),
                },
              ],
            },
          ]}
        />
      </SDrawerOrModal>
      <BelongProductLibraryModal
        open={state.productCategoryModalOpen}
        ids={state.selectedRowKeys}
        onClose={() => setState({productCategoryModalOpen: false, selectedRowKeys: []})}
        onReload={listRef.current?.reload}
      />
      <RelatedConstructionModal
        open={state.relatedConstructionModalOpen}
        ids={state.selectedRowKeys}
        categoryId={state.record?.id}
        onClose={() => setState({relatedConstructionModalOpen: false, selectedRowKeys: [], record: {}})}
        onReload={listRef.current?.reload}
      />
    </div>
  )
}
